import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
// ¡Importante! Configura el worker de pdfjs. Esto es necesario para que el lector funcione.
// Asegúrate de que esta ruta sea correcta para tu versión de create-react-app o Vite.
pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

//RepPrA
function PdfViewer({ pdfFile }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1); // Muestra la primera página al cargar
  }

  // Opcional: Funciones para navegar entre páginas
  const goToPrevPage = () =>
    setPageNumber(prevPageNumber => (prevPageNumber > 1 ? prevPageNumber - 1 : 1));

  const goToNextPage = () =>
    setPageNumber(prevPageNumber =>
      prevPageNumber < numPages ? prevPageNumber + 1 : numPages
    );

  return (
    <div>
      {/* El componente Document es el contenedor principal.
        'file' puede ser una URL, un Buffer o un objeto File. 
      */}
      <Document
        file={pdfFile}
        onLoadSuccess={onDocumentLoadSuccess}
        loading="Cargando PDF..." // Puedes personalizar el estado de carga
        error="No se pudo cargar el PDF"
      >
        {/* El componente Page renderiza una página específica */}
        <Page pageNumber={pageNumber} />
      </Document>

      {numPages && (
        <div style={{ marginTop: '10px' }}>
          <p>
            Página {pageNumber} de {numPages}
          </p>
          <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
            Anterior
          </button>
          <button onClick={goToNextPage} disabled={pageNumber >= numPages}>
            Siguiente
          </button>
        </div>
      )}
    </div>
  );
}

export default PdfViewer;